module.exports = __webpack_public_path__ + "5f7f740e0605e4e1d1966ff035df58f6.png";